import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { WebApiService } from '../service/web-api.service';
import { environment } from '../../environments/environment';

@Injectable()
export class SelectMultiResourceService {

  constructor(private webApiServece: WebApiService) { }

  /**
   * 代表リソース情報一覧情報取得
   */
  execResourceInfoList(): Observable<any> {
　　const requestParam = {};
　  return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/multi-resource-info-list', requestParam)
     .map(cfResponse => {
        return cfResponse.data;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }

  /**
   * リソース選択
   * @param parentResourceId 選択された親リソースID
   * @param resourceId 選択されたリソースID
   */
  execSelectResource(parentResourceId: string, resourceId: string) {
    const requestParam = { 'parent_resource_id': parentResourceId, 'resource_id': resourceId};
　  return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/select-multi-resource', requestParam)
     .map(cfResponse => {
        const data = cfResponse.data;
        // NGの場合はメッセージ、正常の場合はnullを返却
        if (! data.result) {
          return data.messages;
        }
        return null;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }

}
